import apiEndpoints from "./api-endpoints";
import apiRequest from './api-request';


export default {
    mixins: [apiRequest, apiEndpoints],
    methods: {
        getMapToken() {
            // if a transaction is already in progress,
            // just return the existing promise instead
            // of making a new request.
            if (this.mapTokenPromise !== null) {
                return this.mapTokenPromise;
            }
            // get an access token from here maps from the server
            if (this.$store.state.mapToken != null && (this.$store.state.mapToken.expires_at >= Math.floor(Date.now() / 1000))) {
                // use the stored token packed into a promise for compatibility
                return Promise.resolve(this.$store.state.mapToken.access_token);
            }
            // the token is null, or expired, so get a new one from the server.
            console.log("Getting new map access token.");
            this.mapTokenPromise = this.apiRequest(this.apiEndpoints.getMapToken, null).then(response => {
                if (this.checkStatus(response, "Error getting map access token from server!")){
                    this.mapTokenPromise = null;
                    this.$store.commit('setMapToken', response.body);
                    console.log("Map access token stored");
                    return response.body.access_token;
                }

                return false;
            });

            return this.mapTokenPromise;
        },
        //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
        //:::                                                                         :::
        //:::  This routine calculates the distance between two points (given the     :::
        //:::  latitude/longitude of those points). It is being used to calculate     :::
        //:::  the distance between two locations using GeoDataSource (TM) prodducts  :::
        //:::                                                                         :::
        //:::  Definitions:                                                           :::
        //:::    South latitudes are negative, east longitudes are positive           :::
        //:::                                                                         :::
        //:::  Passed to function:                                                    :::
        //:::    lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)  :::
        //:::    lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)  :::
        //:::    unit = the unit you desire for results                               :::
        //:::           where: 'M' is statute miles (default)                         :::
        //:::                  'K' is kilometers                                      :::
        //:::                  'N' is nautical miles                                  :::
        //:::                                                                         :::
        //:::  Worldwide cities and other features databases with latitude longitude  :::
        //:::  are available at https://www.geodatasource.com                         :::
        //:::                                                                         :::
        //:::  For enquiries, please contact sales@geodatasource.com                  :::
        //:::                                                                         :::
        //:::  Official Web site: https://www.geodatasource.com                       :::
        //:::                                                                         :::
        //:::               GeoDataSource.com (C) All Rights Reserved 2018            :::
        //:::                                                                         :::
        //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
        distance(lat1, lon1, lat2, lon2, unit) {
            if (lat1 == lat2 && lon1 == lon2) {
                return 0;
            } else {
                var radlat1 = (Math.PI * lat1) / 180;
                var radlat2 = (Math.PI * lat2) / 180;
                var theta = lon1 - lon2;
                var radtheta = (Math.PI * theta) / 180;
                var dist =
                    Math.sin(radlat1) * Math.sin(radlat2) +
                    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                    dist = 1;
                }
                dist = Math.acos(dist);
                dist = (dist * 180) / Math.PI;
                dist = dist * 60 * 1.1515;
                if (unit == "K") {
                    dist = dist * 1.609344;
                }
                if (unit == "N") {
                    dist = dist * 0.8684;
                }
                return dist;
            }
        },
        getAddress(latitude, longitude) {
            let src = "https://revgeocode.search.hereapi.com/v1/revgeocode";
            return this.getMapToken().then(token => {
                let headers = { Authorization: "Bearer " + token };

                var options = {
                    method: "GET",
                    headers: headers
                };

                var url = new URL(src);
                url.searchParams.append("at", latitude + "," + longitude);
                url.searchParams.append("lang", "en-GB");

                return fetch(url, options)
                    .then(r => r.json())
                    .then(jsonData => {
                        if(jsonData.items && jsonData.items[0]){
                            return Promise.resolve(jsonData.items[0].title);
                        }
                        return Promise.resolve(false);
                    })
                    .catch(ex => {
                        console.error("Exception in promise of address fetch statge:");
                        console.error(ex);
                    });
            });
        }
    },

}
